import { Box, TextNew, TextNewProps } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { ArrowInterface, PaginationControllerInterface } from './PaginationInterfaceEnums'

const returnDefaultPage = (defaultPage: number) => {
  //1 page is for Transaction and Settlements and 1 is for Payment links
  //This means whether the API's default pagination is set to 0 or 1.
  return defaultPage
}

const hideLeftArrow = (totalPages: number, currentPage: number, defaultPageFromAPI: number) => {
  if (currentPage === defaultPageFromAPI || (totalPages === 0 && currentPage === 0)) {
    return true
  } else if (totalPages >= currentPage) {
    return false
  } else {
    return true
  }
}

const hideRightArrow = (totalPages: number, currentPage: number, defaultPage: number) => {
  const lastPage = defaultPage === 0 ? currentPage + 1 : currentPage
  if (totalPages === lastPage || (totalPages === 0 && currentPage === 0 && defaultPage === 0)) {
    return true
  } else {
    return false
  }
}

const ArrowControls = ({ isLeft, onPress, hide }: ArrowInterface) => {
  return (
    <Box
      onPress={onPress}
      testID={isLeft ? 'pagination-left' : 'pagination-right'}
      borderLeftWidth={isLeft ? 0 : 1}
      borderRightWidth={isLeft ? 1 : 0}
      disabled={hide}
      underlayColor="DISABLED_GREY"
      ph={3}
      justify="center"
      borderColor="DISABLED_GREY">
      <Icon id={isLeft ? 'ARROW_LEFT' : 'ARROW_RIGHT'} size={18} color={hide ? 'DISABLED_GREY' : 'BLACK_21'} />
    </Box>
  )
}

const getFromDate = (
  currentPage: number,
  totalPages: number,
  totalDataLength: number,
  dataSetSize: number,
  defaultPageFromAPI: number,
) => {
  if (currentPage === totalPages && totalDataLength < 10 && totalDataLength > 0) {
    //If API has some data but it is less than 10 and no pagination is there.
    return 1
  } else if (currentPage === totalPages && totalDataLength === 0) {
    //If API has no data.
    return 0
  } else {
    //If API has data with pagination.
    //In left logic 1 is added because the page starts from o and anything multiplied with 0 is 0 so added 1
    //Right logic has 1 substracted from current page because initially it shall start from 1 and then it shall go on adding 10 to it
    return defaultPageFromAPI === 0 ? currentPage * dataSetSize + 1 : (currentPage - 1) * dataSetSize + 1
  }
}

const getToDate = (
  currentPage: number,
  totalPages: number,
  totalDataLength: number,
  dataSetSize: number,
  defaultPageFromAPI: number,
  isZeroIndex: boolean,
) => {
  const isLastPage = (isZeroIndex && currentPage === totalPages - 1) || currentPage === totalPages
  if (isLastPage) {
    //Return the total ele if the length is less than 10
    return totalDataLength
  } else if (currentPage === defaultPageFromAPI && totalDataLength > 10) {
    return dataSetSize
  } else {
    //1 is added to compensate the API with 0 as initial index
    return defaultPageFromAPI === 0 ? dataSetSize * (currentPage + 1) : dataSetSize * currentPage
  }
}

export const PaginationController = ({
  hide = false,
  totalDataLength = 10,
  dataSetSize = 10,
  onSelect,
  currentPage,
  totalPages,
  defaultPage = 0,
  isZeroIndex = false,
}: PaginationControllerInterface) => {
  const defaultPageFromAPI = returnDefaultPage(defaultPage)

  const onLeftArrowPress = () => {
    onSelect(currentPage - 1)
  }
  const onRightArrowPress = () => {
    onSelect(currentPage + 1)
  }
  if (hide) {
    return null
  }
  return (
    <Box alignSelf="flex-start" mt={3} borderWidth={1} borderColor="DISABLED_GREY" borderRadius={4} flexDirection="row">
      <ArrowControls
        isLeft={true}
        onPress={onLeftArrowPress}
        hide={hideLeftArrow(totalPages, currentPage, defaultPageFromAPI)}
      />
      <Box ph={16} justify="center" height={30}>
        <TextNew {...textStyles}>
          <TextNew testID='pagination-range' {...textStyles}>{`${getFromDate(
            currentPage,
            totalPages,
            totalDataLength,
            dataSetSize,
            defaultPageFromAPI,
          )}-${getToDate(
            currentPage,
            totalPages,
            totalDataLength,
            dataSetSize,
            defaultPageFromAPI,
            isZeroIndex,
          )} `}</TextNew> of <TextNew testID='total-count' {...textStyles}>{totalDataLength}</TextNew></TextNew>
      </Box>
      <ArrowControls
        isLeft={false}
        onPress={onRightArrowPress}
        hide={hideRightArrow(totalPages, currentPage, defaultPageFromAPI)}
      />
    </Box>
  )
}

const textStyles = {
  type: 'body12',
  fontWeight: '500',
  color: 'BLACK_21',
  selectable: false
} as TextNewProps

export default { PaginationController }
